export function downloadFile(content, fileName, contentType) {
  var a = document.createElement("a")
  //content = JSON.stringify(content)
  var file = new Blob([content], {type: contentType})
  a.href = URL.createObjectURL(file)
  a.download = fileName
  a.click()
  URL.revokeObjectURL(a.href)
}